<template>
    <div class="animated fadeIn">
        <kgr-form-row
            :label="$t('offering.waitlist.waitlist')"
            :error="error"
            field-name="waitList"
        >
            <kgr-checkbox
                v-model="offering.useWaitList"
                :label="$t('offering.waitlist.useWaitList')"
                style="margin-top: 1em; margin-bottom: 1em;"
                @change="checkUseWaitList"
            />
        </kgr-form-row>
        <div v-show="offering.useWaitList">
            <kgr-form-row
                :label="$t('Art der Warteliste')"
                :error="error"
                field-name="waitListFirstComeFirstServed"
            >
                <kgr-generic-select
                    v-model="waitListType"
                    :options="waitListTypeOptions"
                    display="label"
                    @post-input="offering.waitListFirstComeFirstServed = waitListType.value;"
                />
            </kgr-form-row>
            <kgr-form-row
                v-show="!offering.waitListFirstComeFirstServed"
                :label="$t('offering.waitlist.reservationTimeInMinutes')"
                :error="error"
                field-name="reservationTimeInMinutes"
            >
                <input
                    v-model.number="reservationTimeInHours"
                    type="number"
                    min="0"
                    step="0.01"
                    class="kgr-input"
                    :title="$t('offering.waitlist.reservationTimeInMinutesHint')"
                    @input="updateOfferingReservationTime()"
                />
            </kgr-form-row>
            <kgr-form-row
                v-show="!offering.waitListFirstComeFirstServed"
                :label="$t('offering.waitlist.order')"
                :error="error"
                field-name="waitListOrder"
            >
                <kgr-generic-select
                    v-model="order"
                    :options="waitListOrderOptions"
                    display="label"
                    @post-input="offering.order = order.value;"
                />
            </kgr-form-row>
        </div>
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow.vue';
import GenericSelect from '../common/form/select/GenericSelect.vue';
import Offering from '../../js/dto/offering/Offering';

export default {
    name: 'KgrWaitListSettingComponent',
    components: {
        'kgr-checkbox': Checkbox,
        'kgr-form-row': FormRow,
        'kgr-generic-select': GenericSelect,
    },
    props: {
        offering: {
            type: Offering,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            reservationTimeInHours: 0,
            order: null,
            waitListType: null,
        };
    },
    computed: {
        waitListTypeOptions() {
            return [
                {
                    label: this.$t('Reservierung für die Nächsten auf der Warteliste'),
                    value: false,
                },
                {
                    label: this.$t('Alle Wartenden gleichzeitig informieren (wer zuerst bucht)'),
                    value: true,
                },
            ];
        },
        waitListOrderOptions() {
            return [
                {
                    label: this.$t('offering.waitList.order.sequential'),
                    value: 'sequential',
                },
                {
                    label: this.$t('offering.waitList.order.prefer_members'),
                    value: 'prefer_members',
                },
                {
                    label: this.$t('offering.waitList.order.prefer_guests'),
                    value: 'prefer_guests',
                },
            ];
        },
    },
    created() {
        this.calculateReservationTimeInHours();
        this.waitListType = this.waitListTypeOptions.find((obj) => obj.value === !!this.offering.waitListFirstComeFirstServed);
        if (typeof this.offering.order === 'string') {
            this.order = this.waitListOrderOptions.find((obj) => obj.value === this.offering.order);
        }
    },
    methods: {
        checkUseWaitList() {
            if (!this.offering.useWaitList && this.offering.hasMembersOnWaitList) {
                showAlert(this.$t('offering.useWaitList.warningTitle'), this.$t('offering.useWaitList.warning', {}));
            }
        },
        updateOfferingReservationTime() {
            this.offering.reservationTimeInMinutes = Number.parseInt(Math.ceil(this.reservationTimeInHours * 60));
        },
        calculateReservationTimeInHours() {
            this.reservationTimeInHours = round(this.offering.reservationTimeInMinutes / 60, 2);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
